import { IRegion } from '../../../../types/regions';

/**
 * Реализация позаимстовавана из выдачи ЖК.
 * Формируем 4 столбца, каждый столбец содержит массивы для букв, каждая буква содержит массив регионов.
 *
 * ```js
 * [
 *   [[Алапаевск, Алтуфьево], [Барнаул, Борисоглебск]] // 1-й столбец
 *   [[Владивосток, Владимир], [Гатчина]] // 2-й столбец
 *   // и т.д.
 * ]
 * ```
 */
export function getRegionsByColumns(
  letters: string[],
  regionsByAlphabet: Record<string, IRegion[]>,
  regionsLength: number,
): IRegion[][][] {
  const COLUMNS_COUNT = 4;
  const LETTER_LINE_SPACE = 3; // Пространство, занимаемое буквами
  const REGION_NAME_LINE_SPACE = 2; // Пространство, занимаемое регионами под буквой.

  const columns: IRegion[][][] = [[], [], [], []];
  const maxColumnLength = Math.ceil(
    (regionsLength * REGION_NAME_LINE_SPACE + letters.length * LETTER_LINE_SPACE) / COLUMNS_COUNT,
  );
  const columnsLengthArray = [0, 0, 0, 0];
  let columnIndex = 0;

  letters.forEach(letter => {
    const columnLettersCount = columns[columnIndex].length;
    const lettersSpace = columnLettersCount * LETTER_LINE_SPACE;
    const regionsSpace = columnsLengthArray[columnIndex] * REGION_NAME_LINE_SPACE;
    const isColumnFull = lettersSpace + regionsSpace + regionsByAlphabet[letter].length > maxColumnLength;

    if (isColumnFull) {
      columnIndex = Math.min(columnIndex + 1, COLUMNS_COUNT - 1);
    }

    columns[columnIndex].push(regionsByAlphabet[letter]);
    columnsLengthArray[columnIndex] += regionsByAlphabet[letter].length;
  });

  return columns;
}
